export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15117.c0e7a22e.jpg";